import { render } from "./CopyInviteLinkBtn.vue?vue&type=template&id=a28b4ede&scoped=true&ts=true"
import script from "./CopyInviteLinkBtn.vue?vue&type=script&lang=ts"
export * from "./CopyInviteLinkBtn.vue?vue&type=script&lang=ts"

import "./CopyInviteLinkBtn.vue?vue&type=style&index=0&id=a28b4ede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28b4ede"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
